(function () {
  'use strict';

  var VARIANT_ID   = 61747764756810;
  var THRESHOLD    = 7500;
  var busy         = false;
  var ourOperation = false; // onderscheidt onze eigen cart-calls van klantenacties
  var timer        = null;

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkAndUpdate, 400);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    return fetch('/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var newI = doc.getElementById('CartDrawer-CartItems');
        var curI = document.getElementById('CartDrawer-CartItems');
        if (newI && curI) curI.innerHTML = newI.innerHTML;
        var newF = doc.querySelector('.cart-drawer__footer');
        var curF = document.querySelector('.cart-drawer__footer');
        if (newF && curF) curF.innerHTML = newF.innerHTML;
      });
  }

  function checkAndUpdate() {
    if (busy) return;
    busy = true;

    getCart()
      .then(function (cart) {
        var sampleItem = null;
        var subtotal   = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === VARIANT_ID) {
            sampleItem = item;
          } else {
            subtotal += item.original_line_price;
          }
        });

        ourOperation = true;

        if (subtotal >= THRESHOLD && !sampleItem) {
          // Toevoegen
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
          }).then(refreshDrawer);

        } else if (subtotal >= THRESHOLD && sampleItem && sampleItem.quantity > 1) {
          // Teveel samples — terugzetten naar 1
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: sampleItem.key, quantity: 1 })
          }).then(refreshDrawer);

        } else if (subtotal < THRESHOLD && sampleItem) {
          // Verwijderen
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: sampleItem.key, quantity: 0 })
          }).then(refreshDrawer);

        } else {
          ourOperation = false;
        }
      })
      .catch(function () { ourOperation = false; })
      .then(function () {
        setTimeout(function () {
          ourOperation = false;
          busy = false;
        }, 500);
      });
  }

  // Intercept window.fetch — pakt alle Dawn cart-calls
  var _fetch = window.fetch;
  window.fetch = function (url, opts) {
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      if (!ourOperation) {
        p.then(function () { scheduleCheck(); });
      }
    }
    return p;
  };

  // Check bij laden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdate);
  } else {
    checkAndUpdate();
  }

}());
